<template>
  <div class="chart-data-update-time">
    <c-tooltip
      placement="bottom-right"
      :content="tipContent()"
      v-if="getStrFullLength(tipContent()) > 40"
      :width="420"
    >
      <span class="update-time">数据更新时间:&nbsp;{{ dataUpdateTime }}</span>
    </c-tooltip>
    <c-tooltip placement="bottom-right" :content="tipContent()" v-else>
      <span class="update-time">数据更新时间:&nbsp;{{ dataUpdateTime }}</span>
    </c-tooltip>
  </div>
</template>

<script>
import { util } from '../../utils'
import { actions } from '../../store/constants'
export default {
  name: 'eventDataUpdateTime',
  props: {
    isRealTime: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    platId: {
      type: Number,
      default: () => {
        return 0
      }
    },
    dimensionConditions: {
      type: Object,
      default: () => {
        return null
      }
    },
    filterConditions: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      dataUpdateTime: '-'
    }
  },
  created () {
    this.queryDataUpdateTime()
  },
  methods: {
    getStrFullLength (str) {
      return util.getStrFullLength(str || '')
    },
    /**
     * 获取报表实时更新提示
     * @param dimensionConditions
     * @param filterConditions
     * @returns {string}
     */
    getChartRealTimeTip (dimensionConditions, filterConditions) {
      let text = '当前图表数据实时更新，约每分钟更新一次'
      let userRealTimeProps = ['name', 'is_anonymous', 'zg_id', 'app_user_id'] // 用户实时属性：名称、类型、诸葛ID 、用户ID
      let nonRealTimeProps = [] // 非实时属性的text数组
      if (
        dimensionConditions &&
        dimensionConditions.hasOwnProperty('realTime') &&
        !dimensionConditions.realTime
      ) {
        nonRealTimeProps.push(dimensionConditions.text)
      }
      if (util.isObject(filterConditions)) {
        let userProp = filterConditions.userCondition.userSingleConditions
        userProp.forEach(item => {
          if (
            item.category === 'fixed' &&
            !userRealTimeProps.includes(item.name) &&
            !nonRealTimeProps.includes(item.text)
          ) {
            nonRealTimeProps.push(item.text)
          }
        })
      }
      if (util.isArray(filterConditions)) {
        filterConditions.forEach(item => {
          let value = item.value
          let condition = value ? value.condition : {}
          if (
            value &&
            value.isUserProp &&
            condition.category === 'fixed' &&
            !userRealTimeProps.includes(condition.name) &&
            !nonRealTimeProps.includes(condition.text)
          ) {
            nonRealTimeProps.push(condition.text)
          }
        })
      }
      // 如果：细分／筛选 中含有非实时属性
      if (nonRealTimeProps.length) {
        text =
          '当前图表数据实时更新，约每分钟更新一次。但由于属性"' +
          nonRealTimeProps.join(',') +
          '"每天凌晨更新一次，今天产生的数据未能参与计算，展示数据跟真实数据可能有细微差异。'
      }
      return text
    },
    tipContent () {
      if (!this.isRealTime) {
        return '当前图标数据每天更新一次'
      }
      return this.getChartRealTimeTip(
        this.dimensionConditions,
        this.filterConditions
      )
    },
    queryDataUpdateTime () {
      this.dataUpdateTime = util.dateTimeFormat(new Date(), 'yyyy-mm-dd hh:mm')
      if (!this.isRealTime) {
        this.$store
          .dispatch(actions.analysis.appUpdateTime, this.platId)
          .then(res => {
            this.dataUpdateTime = res.times.update_time || '-'
          })
          .catch(error => {
            if (error.__CANCEL__) return
            console.error('数据更新时间查询失败', error)
          })
      }
    }
  }
}
</script>

<style lang="sass">
.chart-data-update-time
  position: absolute
  z-index: 1
  top: 10px
  right: 10px
  font-size: 14px
  color: #666666
  .update-time
    text-decoration: underline
</style>
